export enum MediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  PDF = "PDF",
}
